import $ from  "jquery";
window.$ = window.jQuery = $;
//import * as Bootstrap from  "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import Alpine from "alpinejs";
window.Alpine = Alpine;
//window.Bootstrap = Bootstrap;

